import React from "react";
import { FaXTwitter, FaTiktok } from "react-icons/fa6";
import { FaLinkedin, FaInstagram } from "react-icons/fa";
import { YouTube } from "@mui/icons-material";
import logo from "../../../assets/images/jobHarvestTransparent.png";

const socialLinks = [
  { icon: <FaXTwitter size={16} />, href: "https://x.com/JobHarvest" },
  {
    icon: <YouTube sx={{ fontSize: "18px" }} />,
    href: "https://www.youtube.com/@JobHarvest",
  },
  {
    icon: <FaInstagram size={16} />,
    href: "https://instagram.com/JobHarvest_Official",
  },
  { icon: <FaTiktok size={16} />, href: "https://www.tiktok.com/@JobHarvest" },
  {
    icon: <FaLinkedin size={16} />,
    href: "https://www.linkedin.com/company/105993288",
  },
];

const CinematicFooter = () => {
  return (
    <footer className="cinematic-footer">
      <div className="cinematic-footer__inner">
        <div className="cinematic-footer__grid">
          {/* Brand */}
          <div className="cinematic-footer__brand">
            <div className="cinematic-footer__brand-name">
              <img
                src={logo}
                alt="JobHarvest"
                style={{ width: 28, height: 28, objectFit: "contain" }}
              />
              JobHarvest
            </div>
            <p className="cinematic-footer__brand-desc">
              The leading auto-apply platform. Just swipe and we apply for
              you, helping you land your dream job faster.
            </p>
            <div className="cinematic-footer__social">
              {socialLinks.map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  className="cinematic-footer__social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="cinematic-footer__column-title">Company</h4>
            <ul className="cinematic-footer__column-links">
              <li>
                <a href="/landing-pages/coming-soon">Careers</a>
              </li>
              <li>
                <a href="/landing-pages/coming-soon">Blog</a>
              </li>
              <li>
                <a href="/landing-pages/contact">Contact</a>
              </li>
            </ul>
          </div>

          {/* Product */}
          <div>
            <h4 className="cinematic-footer__column-title">Product</h4>
            <ul className="cinematic-footer__column-links">
              <li>
                <a href="/mobile-app">Mobile App</a>
              </li>
              <li>
                <a href="/#features">Features</a>
              </li>
              <li>
                <a href="/landing-pages/pricing">Pricing</a>
              </li>
              <li>
                <a href="/landing-pages/coming-soon">Integrations</a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="cinematic-footer__column-title">Resources</h4>
            <ul className="cinematic-footer__column-links">
              <li>
                <a href="/landing-pages/faq">FAQ</a>
              </li>
              <li>
                <a href="/landing-pages/contact">Help Center</a>
              </li>
              <li>
                <a href="/landing-pages/privacy">Privacy</a>
              </li>
              <li>
                <a href="/landing-pages/terms">Terms</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="cinematic-footer__bottom">
          {/* Was a hardcoded "All Systems Operational" that stayed green
              through any outage, which is a statement about service health we
              were not actually measuring. Wire this to a real status source
              before claiming uptime again. */}
          <div className="cinematic-footer__status">
            <span className="cinematic-footer__status-dot" />
            Applying to jobs since 2025
          </div>

          <p className="cinematic-footer__copyright">
            &copy; {new Date().getFullYear()} JobHarvest. All rights reserved.
          </p>

          <div className="cinematic-footer__legal">
            <a href="/landing-pages/privacy">Privacy</a>
            <a href="/landing-pages/terms">Terms</a>
            <a href="mailto:contact@jobharvest.com">contact@jobharvest.com</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CinematicFooter;
